module.exports = __webpack_public_path__ + "static/img/cert6.47e8c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/cert6.png
// module id = /SUu
// module chunks = 52